<div class="inputcontainer {{ container_class }}" [ngClass]="{ 'mb-1': error }">
  <input
    [id]="id"
    [(ngModel)]="ref_object[property]"
    placeholder="{{ placeholder }}"
    class="ecertnl_input input"
    [ngClass]="{ error: error }"
    [class.wijzigbaar]="wijzigbaar"
    [disabled]="disabled"
    [type]="type"
    [step]="1"
    (blur)="onBlur($event)"
    [pattern]="pattern"
    [title]="tooltip"
    [maxlength]="maxlength"
    (ngModelChange)="checkValue($event)"
  />
  <div
    class="inputClearButtonWrapper"
    [class.hidden]="ref_object[property] == ''"
    *ngIf="clear_button"
  >
    <button
      mat-button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      type="button"
      (click)="reset()"
    >
      <img alt="clear" src="assets/icons/ui-clear.svg" />
    </button>
  </div>
  <div class="danger pt-2 pb-2" *ngIf="error && foutmelding != null">
    <ecert-icon
      class="mr-2 foutmelding"
      [name]="'ui-alert'"
      [canHover]="false"
      width="20px"
    ></ecert-icon>
    <span class="font-italic pt-2">{{ foutmelding | promptvalue | async }}</span
    ><br />
  </div>
</div>
